import React from "react";
import "./App.css";
import { Layout, Menu, theme } from "antd";
import { UserOutlined, EyeOutlined, LaptopOutlined } from "@ant-design/icons";
import {
  BrowserRouter,
  Routes,
  Route,
  Link,
  useLocation,
  Navigate,
} from "react-router-dom";
import User from "./utils/User";
import Dashboard from "./components/Dashboard";
import ResourceTable from "./components/ResourceTable";
import ResourceDetails from "./components/ResourceDetails";
import { userRole } from "./utils/userDetails";

const { Header, Sider } = Layout;

const navMenuItems = [
  { key: "/", icon: <LaptopOutlined />, label: "Dashboard" },
  { key: "/resource", icon: <UserOutlined />, label: "Resource Table" },
  { key: "/resourceDetails", icon: <EyeOutlined />, label: "Profile View" },
];

function App() {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const location = useLocation();

  return (
    <Layout style={{ height: "100vh" }}>
      <Header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 23px",
          backgroundColor: "#001529",
          boxShadow: "0 1px 0 0 #F0F0F0",
        }}
      >
        <Link to="/" style={{ display: "flex" }}>
          <span
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              gap: "40px",
            }}
          >
            <img
              src="https://spanlogo.s3.ap-south-1.amazonaws.com/Spanidea-light-svg-logo.svg"
              alt="logo"
              style={{ height: "30px" }}
            />
            <div
              style={{ color: "#FFFFFF", fontSize: "22px", fontWeight: "600" }}
            >
              RMS (Resource Management System)
            </div>
          </span>
        </Link>
        <User />
      </Header>

      <Layout>
        <Sider
          collapsible
          collapsedWidth={80}
          breakpoint="md"
          width={200}
          style={{
            background: colorBgContainer,
          }}
          // trigger={null}
        >
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            style={{
              height: "100%",
              borderRight: 0,
            }}
          >
            {navMenuItems
              .filter(
                ({ key }) => userRole === "admin" || key === "/resourceDetails"
              )
              .map(({ key, icon, label }) => (
                <Menu.Item key={key} icon={icon}>
                  <Link to={key}>{label}</Link>
                </Menu.Item>
              ))}
          </Menu>
        </Sider>
        <Layout className="contentWrapper">
          <div
            style={{
              padding: "5px 5px 2px 5px",
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            <Routes>
              {userRole === "admin" ? (
                <>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/resource" element={<ResourceTable />} />
                  <Route
                    path="/resourceDetails"
                    element={<ResourceDetails />}
                  />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </>
              ) : (
                <>
                  <Route
                    path="/resourceDetails"
                    element={<ResourceDetails />}
                  />
                  <Route
                    path="*"
                    element={<Navigate to="/resourceDetails" replace />}
                  />
                </>
              )}
            </Routes>
          </div>
        </Layout>
      </Layout>
    </Layout>
  );
}

function AppWrapper() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

export default AppWrapper;
